import { render, staticRenderFns } from "./global-dashboard-view.vue?vue&type=template&id=1d5416fa"
import script from "./global-dashboard-view.vue?vue&type=script&lang=js"
export * from "./global-dashboard-view.vue?vue&type=script&lang=js"
import style0 from "./global-dashboard-view.vue?vue&type=style&index=0&id=1d5416fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports